import { taskTypeDynamicFieldApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectMasterCompanyId } from 'store/auth/selectors';

export const TASK_TYPE_DYNAMIC_FIELD_TYPE = createNamedActions('taskTypeDynamicField', {
  GET_TASK_TYPE_DYNAMIC_FIELD_VARIABLES: 'GET_TASK_TYPE_DYNAMIC_FIELD_VARIABLES',
});

export const getTaskTypeDynamicFieldAction = catchAsyncActionError(
  () => async (dispatch, getState) => {
    const { data } = await taskTypeDynamicFieldApi.getFields({
      companyId: selectMasterCompanyId(getState()),
    });

    return dispatch({
      type: TASK_TYPE_DYNAMIC_FIELD_TYPE.GET_TASK_TYPE_DYNAMIC_FIELD_VARIABLES,
      payload: data,
    });
  },
);
